import { LegacyAmenities } from '@models/Amenities';
import { Contact } from '@models/Contact';
import { LegacyHomeDetails } from '@models/HomeDetails';
import { LegacyRentProjectionRequest } from '@models/RentProjectionRequest';
import { SalesforceWebToLead } from '@models/SalesforceWebToLead';
import { LegacySurroundings } from '@models/Surroundings';
import { selector } from 'recoil';
import {
    addressAtom,
    bathsAtom,
    bedroomsAtom,
    emailAtom,
    estimatedMarketValueAtom,
    firstNameAtom,
    googlePlaceIdAtom,
    hasCommunityHotTubAtom,
    hasCommunityPoolAtom,
    hasPrivateHotTubAtom,
    hasPrivatePoolAtom,
    hasWaterfrontAtom,
    hasSkiInOutAtom,
    isPetFriendlyAtom,
    lakefrontAtom,
    lastNameAtom,
    oceanfrontAtom,
    phoneAtom,
    riverfrontAtom,
    sfWebToLeadAtom,
    sleepsAtom,
    squareFootageAtom,
    hasOceanViewAtom,
    homeQualityAtom
} from './atoms';

/**
 * @deprecated
 */
export const amenitiesSelector = selector<LegacyAmenities>({
    key: 'legacyAmenitiesSelector',
    get: ({ get }) => {
        return {
            has_community_pool: get(hasCommunityPoolAtom),
            has_community_hot_tub: get(hasCommunityHotTubAtom),
            has_private_hot_tub: get(hasPrivateHotTubAtom),
            has_private_pool: get(hasPrivatePoolAtom),
            has_ski_in_ski_out: get(hasSkiInOutAtom),
            has_waterfront: get(hasWaterfrontAtom),
        };
    },
});

/**
 * @deprecated
 */
export const surroundingsSelector = selector<LegacySurroundings>({
    key: 'legacySurroundingsSelector',
    get: ({ get }) => {
        return {
            lakefront: get(lakefrontAtom),
            hasOceanView: get(hasOceanViewAtom),
            oceanfront: get(oceanfrontAtom),
            riverfront: get(riverfrontAtom),
        };
    },
});

/**
 * @deprecated
 */
const homeDetailsSelector = selector<LegacyHomeDetails>({
    key: 'legacyHomeDetailsSelector',
    get: ({ get }) => {
        return {
            baths: get(bathsAtom),
            bedrooms: get(bedroomsAtom),
            sleeps: get(sleepsAtom),
            squareFootage: get(squareFootageAtom),
            estimatedMarketValue: get(estimatedMarketValueAtom),
            homeQuality: get(homeQualityAtom),
            ...get(amenitiesSelector),
        };
    },
});

/**
 * @deprecated
 */
export const rentProjectionRequestSelector = selector<LegacyRentProjectionRequest | undefined>({
    key: 'legacyRentProjectionRequestSelector',
    get: ({ get }) => {
        const address = get(addressAtom);
        if (address) {
            return {
                address,
                ...get(homeDetailsSelector),
                ...get(surroundingsSelector),
            };
        }

        const googlePlaceId = get(googlePlaceIdAtom);
        if (googlePlaceId) {
            return {
                googlePlaceId,
                ...get(homeDetailsSelector),
                ...get(surroundingsSelector),
            };
        }
        return undefined;
    },
});

const contactSelector = selector<Contact | undefined>({
    key: 'contactSelector',
    get: ({ get }) => {
        const firstName = get(firstNameAtom);
        const lastName = get(lastNameAtom);
        const email = get(emailAtom);
        if (!firstName || !lastName || !email) {
            return undefined;
        }

        const phone = get(phoneAtom);

        return {
            firstName,
            lastName,
            phone,
            email,
        };
    },
});

const sfAmenitiesSelector = selector({
    key: 'sfAmenitiesSelector',
    get: ({ get }) => {
        const amenities: string[] = [];
        if (get(hasCommunityHotTubAtom)) {
            amenities.push('Community Hot Tub');
        }
        if (get(hasCommunityPoolAtom)) {
            amenities.push('Community Swimming Pool');
        }
        if (get(hasPrivateHotTubAtom)) {
            amenities.push('Private Hot Tub');
        }
        if (get(hasPrivatePoolAtom)) {
            amenities.push('Private Swimming Pool');
        }
        if (get(hasWaterfrontAtom)) {
            amenities.push('Waterfront');
        }
        if (get(hasSkiInOutAtom)) {
            amenities.push('Ski-in/ski-out');
        }


        return amenities.join(';');
    },
});

// const sfSurroundingsSelector = selector({
//     key: 'sfSurroundingsSelector',
//     get: ({ get }) => {
//         const surroundings: string[] = [];

//         return surroundings.join(';');
//     },
// });

// const sfPremiumServicesSelector = selector({
//     key: 'sfPremiumServicesSelector',
//     get: ({ get }) => {
//         const premiumServices: string[] = [];

//         return premiumServices.join(';');
//     },
// });

export const sfWebToLeadSelector = selector<SalesforceWebToLead | undefined>({
    key: 'sfWebToLeadSelector',
    get: ({ get }) => {
        const googlePlaceID = get(googlePlaceIdAtom);
        if (!googlePlaceID) {
            return undefined;
        }

        const contact = get(contactSelector);
        if (!contact) {
            return undefined;
        }

        return {
            ...get(sfWebToLeadAtom),
            googlePlaceID,
            ...contact,
            bedrooms: get(bedroomsAtom),
            bathrooms: get(bathsAtom),
            amenities: get(sfAmenitiesSelector),
            surroundings: '',
            premiumServices: '',
            dogFriendly: get(isPetFriendlyAtom),
        };
    },
});
